import React from "react";
import AddChildDevice from "../../../../assets/images/addChildDevice.png";
import { useHistory } from "react-router-dom";
import { setAddKidStatus, setNewKidData } from "../../AxiosRtk/AddNewChild";
import { useDispatch } from "react-redux";

const AddAChildDevice = ({ getLangTranslation }) => {
	const history = useHistory();
	const dispatch = useDispatch();

	function handleNext() {
		history.push("/connect-child-device")
		dispatch(setAddKidStatus('CONNECT_CHILD_DEVICE'));
	}

	function handleAddDeviceLater() {
		history.push("/dashboard")
		dispatch(setAddKidStatus(''));
		dispatch(setNewKidData(null));
	}

	return (
		<div className="card">
			<div className="card-body">
				<div className="content-550 mx-auto text-center">
					<h2 className="text-center mb-3">{getLangTranslation('ADD_CHILD_DEVICE', "Add a child device")}</h2>
					<div className="my-9">
						<img src={AddChildDevice} alt='' />
					</div>
					<h5 className="my-9">
						{getLangTranslation('IF_YOU_DID_NOT_INSTALL', "If you did not install the Kido Protect app on your child's device, please start by installing it.")}
					</h5>
					<div className="grid gap-3">
						<button
							className="btn btn-outline-primary g-col-6"
							type="button"
							onClick={handleAddDeviceLater}
						>
							<span className="btn-upper-case">
								{getLangTranslation('ADD_LATER_BTN_TXT', "ADD LATER")}
							</span>
						</button>
						<button
							className="btn btn-primary g-col-6"
							type="button"
							onClick={handleNext}
						>
							<span className="btn-upper-case">
								{getLangTranslation('NEXT', 'NEXT')}
							</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	)
}

export default AddAChildDevice;